var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1q.475 0 .788-.312.312-.313.312-.788v-3.925q0-.475-.312-.775-.313-.3-.788-.3-.475 0-.787.312-.313.313-.313.788v3.925q0 .45.313.763.312.312.787.312Zm0-7.975q.475 0 .8-.325.325-.325.325-.8 0-.475-.325-.8-.325-.325-.8-.325-.475 0-.8.325-.325.325-.325.8 0 .475.325.8.325.325.8.325ZM12 22.2q-2.125 0-3.988-.8-1.862-.8-3.237-2.175Q3.4 17.85 2.6 15.988 1.8 14.125 1.8 12t.8-3.988q.8-1.862 2.175-3.237Q6.15 3.4 8.012 2.6 9.875 1.8 12 1.8t3.988.8q1.862.8 3.237 2.175Q20.6 6.15 21.4 8.012q.8 1.863.8 3.988t-.8 3.988q-.8 1.862-2.175 3.237Q17.85 20.6 15.988 21.4q-1.863.8-3.988.8ZM12 12Zm0 7.925q3.3 0 5.613-2.312Q19.925 15.3 19.925 12q0-3.3-2.312-5.613Q15.3 4.075 12 4.075q-3.3 0-5.612 2.312Q4.075 8.7 4.075 12q0 3.3 2.313 5.613Q8.7 19.925 12 19.925Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.de119adcc7fd072bc6c5e0e2683faa07.svg";
export { ForwardRef as ReactComponent };